<template>
    <div id="burger"         
         :class="{ 'active' : isNavActive }"
         @click.prevent="toggle">         
        <slot>
            <button type="button" class="burger-button" title="Menu">
                 <span class="burger-chevron"><svg viewBox="0 0 6.3 9.4"><g id="Ebene_2" data-name="Ebene 2"><g id="Ebene_1-2" data-name="Ebene 1"><polygon class="cls-1" points="1.4 9.4 0 7.9 3.5 4.5 0.4 1.4 1.8 0 6.3 4.5 1.4 9.4"/></g></g></svg></span>
                <span class="burger-bar burger-bar--1"></span>
                <span class="burger-bar burger-bar--2"></span>
                <span class="burger-bar burger-bar--2a"></span>
                <span class="burger-bar burger-bar--3"></span>
            </button>
        </slot>
    </div>
</template>
<script>
    export default {
        props: {
            navType: {
                type: String,
            }
        },
        data() {
          return {
            //isNavActive: this.$store.state.isArchiveNavOpen
          }
        },
        methods: {
            toggle() {
                this.isNavActive = !this.isNavActive                
                //this.$store.commit('changeArchiveNavState', {'active': this.isNavActive, 'type': this.navType} )                
            }
        },
        computed: {
          isNavActive: {
            get() {  
              if (this.navType == "Book"){
                  return this.$store.state.navStates.isBookNavOpen
              } 
              else if (this.navType == "Media"){
                  return this.$store.state.navStates.isMediaNavOpen
              } 
              else if (this.navType == "Genese"){
                  return this.$store.state.navStates.isGenesisNavOpen
              }                
              else {
                  return this.$store.state.navStates.isArchiveNavOpen
              }          
              
            },
            set(value) {

              this.$store.commit('changeArchiveNavState', {'active': value, 'type': this.navType} )              
            }
          }
        }
    }
</script>
<style lang="scss">
    #burger {
        position: fixed;
        top:0px;
        left: 0px;
        z-index:5000;
        transition: left 1.4s, opacity .5s;
        opacity: 1;
    }
   .hidden {
        visibility: hidden;
    }

    button {
        cursor: pointer;
    }

    /* remove blue outline */
    button:focus {
        outline: 0;
    }

    .burger-button {
        position: relative;
        height: 42px;
        width: 42px;
        display: block;
        z-index: 999;
        border: 0;
        border-radius: 0;
        background-color: black;
        pointer-events: all;
        transition: transform .6s cubic-bezier(.165,.84,.44,1);

    }

    .burger-chevron {
        position: absolute;
        top: 25%;
        left: 65%;
        font-size: 12px;
        font-weight: 500;
        fill: white;
        svg {
            width: 7px;
        }

    }

    .burger-bar {
        background-color: white;
        position: absolute;
        top: 50%;
        right: 8px;
        left: 8px;
        height: 2px;
        width: auto;
        margin-top: -1px;
        transition: transform .6s cubic-bezier(.165,.84,.44,1),opacity .3s cubic-bezier(.165,.84,.44,1),background-color .6s cubic-bezier(.165,.84,.44,1);
    }

    .burger-bar--1 {        
        transform: translateY(-10px);
    }

    .burger-bar--2 {
        transform-origin: 0% 100%;
        transform: scaleX(.5) translateY(-3px);
    }

    .burger-bar--2a {
        transform-origin: 0% 100%;
        transform: translateY(3px) scaleX(.5);
    }

    .burger-button:hover .burger-bar--2 {
        transform: scaleX(.5) translateY(-3px);
    }

    .no-touchevents .burger-bar--2:hover {
        transform: scaleX(1);
    }

    .burger-button:hover .burger-chevron {
        transform: scaleX(1);
        left: 70%;
    }

    .burger-bar--3 {
        transform: translateY(10px);
    }

    #burger.active  {
      opacity: 0;
    }

/*
    #burger.active .burger-button {
        transform: rotate(-180deg);
    }

    #burger.active .burger-bar {
        background-color:white;
    }

    #burger.active .burger-bar--1 {
        transform: rotate(45deg)
    }

    #burger.active .burger-bar--2 {
        opacity: 0;
    }

    #burger.active .burger-bar--2a {
        opacity: 0;
    }

    #burger.active .burger-chevron {
        opacity: 0;
    }

    #burger.active .burger-bar--3 {
        transform: rotate(-45deg)
    }

    #burger.active .burger-button {
        width:30px;
        height: 30px;
        left:350px;
        
    }
    */

</style>